export default "/assets/images/awards-img-01-sm.svg?0e892e95c4c307648b6fbe255cfaa9d9";